import React from 'react';
import {Button} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import {KeyTag} from "../../api/Model";
import {useKeyTagStore} from "../../api/KeyTagStore";
import {Page, StorePageCount} from "../../components/page/Page";
import {LoadingData} from "../../components/loading-data/LoadingData";
import {KeyTagFormComponent} from "./KeyTagFormComponent";
import {KeyTagTable} from "./KeyTagTable";
import {useDeleteAction} from "../../util/actions/DeleteAction";
import {useFormDialogAction} from "../../components/form-dialog/FormDialogProvider";


export default function KeyTagsPage() {
    const {
        remoteValue: keyTags,
        createKeyTag,
        updateKeyTag,
        deleteKeyTag,
    } = useKeyTagStore();

    const handleCreateTag = useFormDialogAction({
        title: "Create Key Tag",
        description: "Enter the details for the new key tag.",
        submitButtonText: 'Create',
        renderForm: KeyTagFormComponent,
        action: (openDialog) => openDialog({
            initialValue: {
                name: '',
                description: null,
                color: '#3f51b5',
            },
            onSubmit: createKeyTag,
            successMessage: 'Created new key tag',
            errorMessage: 'Failed to create a key tag. Please try again later.',

        })
    }, [createKeyTag]);

    const handleUpdateTag = useFormDialogAction({
        title: "Edit Key Tag",
        description: "Update the key tag information below.",
        submitButtonText: 'Update',
        renderForm: KeyTagFormComponent,
        action: (openDialog, keyTag: KeyTag) => openDialog({
            initialValue: {
                name: keyTag.name,
                description: keyTag.description,
                color: keyTag.color,
            },
            onSubmit: form => updateKeyTag(keyTag, form),
            successMessage: form => `Updated key tag ${form.name}.`,
            errorMessage: 'Failed to update key tag. Please try again later.',
        }),
    }, [updateKeyTag]);

    const handleDeleteTag = useDeleteAction({
        description: 'Are you sure you want to delete this key tag? This action cannot be undone.',
        action: deleteKeyTag,
        successMessage: 'Deleted key tag',
        failureMessage: 'Failed to delete key tag. Please try again later.',
    }, [deleteKeyTag]);

    return (
        <Page
            header="Key Tags"
            counter={<StorePageCount value={keyTags}/>}
            description="Manage key tags for categorizing and organizing keys."
            actions={
                <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddIcon/>}
                    onClick={handleCreateTag}
                >
                    Add Key Tag
                </Button>
            }
        >
            <LoadingData
                value={keyTags}
                emptyMessage="No key tags found."
                defaultErrorMessage="Failed to load key tags. Please try again later."
            >
                {resolved => (
                    <KeyTagTable
                        rows={resolved}
                        onEditTag={handleUpdateTag}
                        onDeleteTag={handleDeleteTag}
                    />
                )}
            </LoadingData>
        </Page>
    );
}
